import React from 'react';

export default function ContextMenu({value, valueName, onClickInclude, onClickExclude, onSampleClick}) {
    const popoverButtonClass = `tlw-w-full tlw-flex tlw-border tlw-border-transparent tlw-text-md tlw-text-gray-900 tlw-rounded-sm tlw-bg-white hover_tlw-bg-blue-400 hover_tlw-text-white focus_tlw-bg-gray-200`;

    return (
        <div
            className='tlw-flex tlw-flex-col tlw-items-start tlw-justify-start tlw-whitespace-nowrap tlw-p-2.5'>
            {onClickInclude &&
            <>
                <button
                    className={`tlw-rounded-t-sm ${popoverButtonClass}`}
                    onClick={() => onClickInclude(value)}
                >
                    Include {valueName}
                </button>
            </>
            }
            {onClickExclude &&
            <>
                <button
                    className={popoverButtonClass}
                    onClick={() => onClickExclude(value)}
                >
                    Exclude {valueName}
                </button>
            </>
            }
            <button
                className={`tlw-rounded-b-sm ${popoverButtonClass}`}
                onClick={() => onSampleClick(value)}
            >
                View sample posts
            </button>
        </div>
    );
}
